import {
  Component,
  AfterViewInit,
  OnInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { AddPermissionsActionAdminComponent } from './add-permissions-action-admin/add-permissions-action-admin.component';
import { EditPermissionsActionAdminComponent } from './edit-permissions-action-admin/edit-permissions-action-admin.component';
import { PermissionsActionAdminService } from './permissions-action-admin.service';
import { PermissionsAction } from './permissions-action-admin.interface';

@Component({
  selector: 'app-permissions-action-admin',
  templateUrl: './permissions-action-admin.component.html',
  styleUrls: ['./permissions-action-admin.component.scss'],
})
export class PermissionsActionAdminComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  isLoading = false;
  showCard = false;
  activeValue: string = '-1';
  publicValue: string = '-1';

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  parameters: { key: string; value: string }[] = [
    { key: '--Alegeți--', value: '-1' },
    { key: 'Da', value: '0' },
    { key: 'Nu', value: '1' },
  ];

  onSelectionChange(event: any): void {
    this.activeValue = event.target.value;
    this.publicValue = event.target.value;
  }

  toggleCard() {
    this.showCard = !this.showCard;
  }

  dtLink =
    environment.interop.basePath +
    environment.interop.platform.nomenclatoare.permissionActions
      .getPermissionActionsDT;

  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private permissionsActionService: PermissionsActionAdminService
  ) {}

  ngOnInit(): void {
    this.renderDT();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next('');
  }

  renderDT() {
    this.isLoading = true;
    this.dtOptions = {
      serverSide: true,
      responsive: true,
      searching: false,
      pageLength: 25,

      ajax: (dataTablesParameters: any, callback: any) => {
        dataTablesParameters.param1 = this.activeValue;
        dataTablesParameters.param2 = this.publicValue;

        this.http
          .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
          .subscribe((res: any) => {
            this.isLoading = false;
            callback({
              recordsTotal: res.data.recordsTotal,
              recordsFiltered: res.data.recordsFiltered,
              data: res.data.data,
            });
          });
      },
      language: environment.config.romanianLanguageDataTable,
      columns: [
        {
          title: 'ID',
          data: 'id',
        },
        {
          title: 'Denumire',
          data: 'name',
        },
        {
          title: 'Permisiune',
          data: 'id_permission',
        },
        {
          title: 'Acțiuni',
          data: null,
          className: 'all',
          orderable: false,
          render: () => {
            return `
            <div class="d-flex align-center justify-content-center">
              <button class="action-btn edit">
                <img class="btn-img" src="/assets/icons/edit.svg" alt="edit"/>
              </button>
              <button class="action-btn delete">
                <img class="btn-img" src="/assets/icons/delete.svg" alt="delete"/>
              </button>
              </div>
            `;
          },
        },
      ],
      rowCallback: (row: Node, data: any[] | any) => {
        const lastTd = (row as HTMLElement).querySelector('td:last-child');
        const editIcon = lastTd?.querySelector('.edit');
        const deleteIcon = lastTd?.querySelector('.delete');

        if (editIcon) {
          editIcon.addEventListener('click', () => {
            this.openEditDialog(data);
          });
        }

        if (deleteIcon) {
          deleteIcon.addEventListener('click', () => {
            const { id } = data;
            this.deletepermissionsAction(id);
          });
        }

        return row;
      },
    };
  }

  rerenderDT(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next('');
    });
  }

  deletepermissionsAction(permissionsActionId: number) {
    Swal.fire({
      title: 'Sunteți sigur?',
      text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Confirm!',
      cancelButtonText: 'Cancel',
      showLoaderOnConfirm: true,
    }).then((res) => {
      if (res.isConfirmed) {
        this.permissionsActionService
          .deletePermissionsAction(permissionsActionId)
          .subscribe(() => {
            this.rerenderDT();
            Swal.fire({
              title: 'Șters!',
              text: 'Acțiune ștearsă cu succes.',
              icon: 'success',
              confirmButtonText: 'OK',
            });
          });
      }
    });
  }

  openAddDialog() {
    const dialogRef = this.dialog.open(AddPermissionsActionAdminComponent, {
      ...this.dialogService.getDialogConfig(),
    });

    dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
      if (success) {
        this.rerenderDT();
      }
    });
  }

  openEditDialog(data: PermissionsAction) {
    const dialogRef = this.dialog.open(EditPermissionsActionAdminComponent, {
      ...this.dialogService.getDialogConfig(),
      data,
    });

    dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
      if (success) {
        this.rerenderDT();
      }
    });
  }
}
